import { render, staticRenderFns } from "./suo-you-xiao-shou.vue?vue&type=template&id=1ce3480f&scoped=true"
import script from "./suo-you-xiao-shou.vue?vue&type=script&lang=js"
export * from "./suo-you-xiao-shou.vue?vue&type=script&lang=js"
import style0 from "./suo-you-xiao-shou.vue?vue&type=style&index=0&id=1ce3480f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_00c06ca9196352b30e67b45b8b60d79f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce3480f",
  null
  
)

export default component.exports